import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  CircularProgress,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Divider from "@mui/material/Divider";
import AddressListItem from "./AddressListItem";
import { useNavigate } from "react-router-dom";
import { useSailorAddresses } from "../../hooks/useSailorAddresses";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { Panel } from "@poseidon/ui/components/Panel";
import { useBaseRoutePathContext } from "@poseidon/utils/base-route-path";

export const AddressManagementSection = ({ sailor }) => {
  const navigate = useNavigate();
  const baseRoutePath = useBaseRoutePathContext();
  const { sailorAddresses, loading, error } = useSailorAddresses({
    sailorId: sailor.id,
  });
  const { setError } = useErrorMessage();

  if (error) {
    setError(error);
  }

  if (loading || !sailorAddresses) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <Panel collapsable startCollapsed={true} title="Address History">
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12}>
          <List>
            <ListItem disablePadding={true} key={1}>
              <ListItemButton
                onClick={() =>
                  navigate(
                    `${baseRoutePath.path}/sailors/${sailor.id}/addresses`
                  )
                }
              >
                <ListItemText primary="Add new Address" />
                <ListItemIcon>
                  <AddCircleOutlineIcon />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <Divider />
            {sailorAddresses?.map((address) => (
              <AddressListItem
                key={`${address.id}`}
                address={address}
                sailorId={sailor.id}
                setDeleted={() =>
                  sailor.addresses.splice(
                    0,
                    sailor.addresses.findIndex((a) => a.id === address.id)
                  )
                }
              />
            ))}
          </List>
        </Grid>
      </Grid>
    </Panel>
  );
};
